import { Component, inject, Input, OnInit } from '@angular/core';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { isSupportTechnique } from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { DisplayRubriqueStatusWithWarningAndCtaComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning-and-cta/display-rubrique-status-with-warning-and-cta.component';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';

@Component({
  selector: 'app-p0003606-injection-ph-statut',
  templateUrl: './p0003606-injection-ph-statut.component.html',
  styleUrls: ['./p0003606-injection-ph-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    DisplayRubriqueStatusWithWarningAndCtaComponent,
    TranslatePipe,
    CollapseComponent,
    IonItem,
    IonLabel,
    IonList,
  ],
})
export class P0003606InjectionPhStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  editValue(index: any, key: string, value: any): void {
    this.actionStack!.editValue(index, key, value);
  }

  commit(): void {
    this.actionStack!.commit();
  }

  acknowledgeUtilisateur(): void {
    this.editValue(
      P00039DataRxTxIndex.InjectionPh_Controle,
      'iphCAckUtilisateur',
      1,
    );
    this.commit();
  }

  resetCompteur(): void {
    this.editValue(
      P00039DataRxTxIndex.InjectionPh_Controle,
      'iphCResetCompteur',
      1,
    );
    this.commit();
  }

  get presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
